import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { BalanceSheetAction, OverallCostDetailAction } from "../actions";
import * as balanceSheetApi from "../api/balanceSheet";
import { toastr } from "react-redux-toastr";
import queryString from "query-string";
import { createBrowserHistory } from "history";
import * as receiveApi from "../api/receive";
import * as paymentApi from "../api/payment";
import * as activityApi from "../api/activity";
import * as transferApi from "../api/transfer";
import {
  ACTIVITY,
  PAYMENT,
  RECEIVE,
  TRANSFER
} from "../constants/accountReviewActionTypes";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherBalanceSheet() {
  yield takeLatest(types.GET_BALANCE_SHEET_REQUEST_FILE, workerFile);
  yield takeLatest(types.GET_BALANCE_SHEET_REQUEST, worker);
  yield takeLatest(types.GET_DETAIL1_BALANCE_SHEET_REQUEST, workerDetail1);
  yield takeLatest(types.GET_DETAIL2_BALANCE_SHEET_REQUEST, workerDetail2);
  yield takeLatest(
    types.API_REMOVE_BALANCE_SHEET_DETAIL2_REQUEST,
    workerRemove
  );
}

function fetchBalanceSheet() {
  return balanceSheetApi.get();
}

function* worker() {
  try {
    const response = yield call(fetchBalanceSheet);
    yield put(BalanceSheetAction.getSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(BalanceSheetAction.getFailure(error));
  }
}

async function fetchBalanceSheetDetail1(id, is_balance_sheet) {
  const history = createBrowserHistory();
  const filters = {
    file_type: "web",
    sort: {
      type: "desc",
      field: "amount"
    },
    filter: {
      text_search: ""
    }
  };
  let urlFilters = await queryString.parse(document.location.search);
  let parsed = {
    ...urlFilters
  };
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  if (history.location.search !== "" && oldSearch !== search) {
    history.push({ search: `?${search}` });
  }

  const finalFilter = {
    file_type: filters.file_type,
    sort: {
      type: urlFilters.sort_type || filters.sort.type,
      field: urlFilters.sort_field || filters.sort.field
    },
    filter: {
      text_search: urlFilters.text_search || filters.filter.text_search
    },
    is_balance_sheet
  };
  return balanceSheetApi.getDetail1(id, finalFilter);
}

function* workerDetail1(action) {
  try {
    const response = yield call(
      fetchBalanceSheetDetail1,
      action.id,
      action.is_balance_sheet
    );
    yield put(BalanceSheetAction.getDetail1Success(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(BalanceSheetAction.getDetail1Failure(error));
  }
}

async function fetchBalanceSheetDetail2(
  parentId,
  id,
  pageNumber,
  is_balance_sheet
) {
  const history = createBrowserHistory();
  const filters = {
    file_type: "web",
    sort: {
      type: "desc",
      field: "date"
    },
    filter: {
      text_search: "",
      start_date: " ",
      end_date: " "
    }
  };
  let urlFilters = await queryString.parse(document.location.search);
  let parsed = {
    ...urlFilters
  };
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  if (history.location.search !== "" && oldSearch !== search) {
    history.push({ search: `?${search}` });
  }

  const finalFilter = {
    file_type: filters.file_type,
    sort: {
      type: urlFilters.sort_type || filters.sort.type,
      field: urlFilters.sort_field || filters.sort.field
    },
    filter: {
      text_search: urlFilters.text_search || filters.filter.text_search,
      start_date: urlFilters.start_date
        ? urlFilters.start_date.replaceAll("-", "/")
        : filters.filter.start_date,
      end_date: urlFilters.end_date
        ? urlFilters.end_date.replaceAll("-", "/")
        : filters.filter.end_date
    },
    is_balance_sheet
  };
  const page_number = pageNumber ? pageNumber : "";
  return balanceSheetApi.getDetail2(parentId, id, finalFilter, page_number);
}

function* workerDetail2(action) {
  try {
    const response = yield call(
      fetchBalanceSheetDetail2,
      action.parentId,
      action.id,
      action.pageNumber,
      action.is_balance_sheet
    );
    yield put(BalanceSheetAction.getDetail2Success(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(BalanceSheetAction.getDetail2Failure(error));
  }
}

function createBalanceSheetFile(file_type, level) {
  return balanceSheetApi.getExport(file_type, level);
}

function* workerFile(action) {
  try {
    const response = yield call(
      createBalanceSheetFile,
      action.file_type,
      action.level
    );
    response.data.message.forEach(message => {
      toastr.error(" ", message.toString());
    });
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

async function remove(id, type) {
  if (type == PAYMENT) {
    return paymentApi.remove(id);
  } else if (type == RECEIVE) {
    return receiveApi.remove(id);
  } else if (type == ACTIVITY) {
    const data = {
      store_list: [],
      update_list: [],
      delete_list: [id]
    };
    return activityApi.store(data);
  } else if (type == TRANSFER) {
    return transferApi.remove(id);
  }
}

function* workerRemove(action) {
  try {
    const res = yield call(remove, action.id, action._type);
    const messages = res.data.message || res.message;
    messages.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const response = yield call(
      fetchBalanceSheetDetail2,
      action.parentId,
      action.pageId,
      action.pageNumber,
      action.is_balance_sheet
    );
    yield put(BalanceSheetAction.removeSuccess(response.data));
  } catch (error) {
    let messages = null;
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        messages = error.response.data.message;
      } else if (error.response.message) {
        messages = error.response.message;
      }
    }
    messages &&
      Array.isArray(messages) &&
      messages.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(BalanceSheetAction.removeFailure(error));
  }
}
